<template>
  <div :class="b()" :style="styleSizeName">
    <div v-show="hasData" :ref="id" :style="styleChartName"></div>
    <template v-if="!hasData">
      <avue-echart-empty />
    </template>
  </div>
</template>

<script>
import { formatByPath } from '@/utils/category';
import init from '@/mixins/chart';
export default {
  name: 'bar2',
  mixins: [init],
  computed: {
    x2() {
      return this.option.gridX2 || 90;
    },
    hasData() {
      return this.dataChart?.series?.length > 0 && this.dataChart?.categories?.length > 0;
    }
  },
  props: {
    goback: Object
  },

  methods: {
    updateChart() {
      const optionData = this.deepClone(this.dataChart);
      const option = {
        title: this.ishasprop(
          this.option.titleShow,
          {
            text: this.option.title,
            subtext: this.option.subtext || '',
            textStyle: {
              color: this.option.titleColor || '#333',
              fontSize: this.option.titleFontSize || 16
            },
            left: this.option.titlePostion || 'auto',
            subtextStyle: {
              color: this.option.subTitleColor || '#aaa',
              fontSize: this.option.subTitleFontSize || 14
            }
          },
          {}
        ),
        tooltip: this.ishasprop(
          this.formatter,
          {
            formatter: name => {
              return this.formatter(name, this.dataChart);
            }
          },
          {
            textStyle: {
              fontSize: this.option.tipFontSize,
              color: this.option.tipColor || '#fff'
            },
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            },
            formatter: params => {
              let result = params[0]?.axisValueLabel;
              for (const param of params) {
                // y2格式化
                let value = param.value;
                const {
                  yAxisShow,
                  yValueFormatPath = [],
                  yAxisSecondShow,
                  yValueSecondFormatPath = []
                } = this.option;
                if (param.seriesIndex === 1) {
                  if (yAxisSecondShow) {
                    if (yValueSecondFormatPath.length > 0) {
                      value = formatByPath(yValueSecondFormatPath, value);
                    }
                  } else {
                    if (yAxisShow && yValueFormatPath.length > 0) {
                      value = formatByPath(yValueFormatPath, value);
                    }
                  }
                  result += `<br/>${param.marker}${param.seriesName}: ${value}`;
                } else {
                  if (yAxisShow && yValueFormatPath.length > 0) {
                    value = formatByPath(yValueFormatPath, value);
                  }
                  result += `<br/>${param.marker}${param.seriesName}: ${value}`;
                }
              }
              return result;
            }
          }
        ),
        grid: {
          left: this.option.gridX || 20,
          top: this.option.gridY || 60,
          right: this.x2,
          bottom: this.option.gridY2 || 60
        },
        legend: {
          show: this.vaildData(this.option.legend, false),
          orient: this.option.legendOrient || 'vertical',
          x: this.option.legendPostion || 'left',
          bottom: 0,
          right: this.x2,
          textStyle: {
            fontSize: this.option.legendFontSize || 12
          },
          data: (() => {
            return (optionData.series || []).map((ele, index) => {
              return {
                name: ele.name,
                textStyle: this.ishasprop(
                  !this.switchTheme,
                  {
                    color: this.getColor(index, true)
                  },
                  {}
                )
              };
            });
          })()
        },
        dataZoom: [
          {
            show: this.vaildData(this.option.barSlide, false),
            height: 30,
            xAxisIndex: [0], // 组件控制的x轴
            bottom: 0,
            start: 0,
            end: 100,
            handleIcon:
              'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
            handleSize: '100%',
            handleStyle: {
              color: this.option.iconColor || 'rgba(11, 29, 227, 0.7)'
            },
            textStyle: {
              color: this.option.textColor || '#fff'
            },
            fillerColor: this.option.slideFillBgc || 'rgba(11, 29, 227, 0.7)',
            borderColor: this.option.slideBorderBgc || 'rgba(11, 29, 227, 0.7)'
          },
          {
            type: 'inside',
            show: true,
            height: 15,
            start: 1,
            end: 35
          }
        ],
        xAxis: {
          type: this.option.category ? 'value' : 'category',
          name: this.option.xAxisName,
          axisLine: {
            lineStyle: {
              color: this.option.lineColor || '#333'
            }
          },
          data: optionData.categories || [],
          inverse: this.vaildData(this.option.xAxisInverse, false),
          show: this.vaildData(this.option.xAxisShow, true),
          splitLine: {
            show: this.vaildData(this.option.xAxisSplitLineShow, false)
          },
          axisLabel: {
            interval: this.option.xAxisinterval || 'auto',
            rotate: this.option.xAxisRotate || 0,
            textStyle: {
              color: this.option.nameColor || '#333',
              fontSize: this.option.xNameFontSize || 14
            }
          }
        },
        yAxis: [
          {
            type: this.option.category ? 'category' : 'value',
            name: this.option.yAxisName,
            data: optionData.categories || [],
            axisLabel: {
              textStyle: {
                color: this.option.nameColor || '#333',
                fontSize: this.option.yNameFontSize || 14
              },
              formatter: value => {
                const { yAxisShow, yValueFormatPath = [] } = this.option;
                if (yAxisShow && yValueFormatPath.length > 0) {
                  return formatByPath(yValueFormatPath, value);
                } else {
                  return value;
                }
              }
            },
            axisLine: {
              lineStyle: {
                color: this.option.lineColor || '#333'
              }
            },
            inverse: this.vaildData(this.option.yAxisInverse, false),
            show: this.vaildData(this.option.yAxisShow, true),
            splitLine: {
              show: this.vaildData(this.option.yAxisSplitLineShow, true)
            }
          },
          {
            type: this.option.category ? '' : 'value',
            name: this.option.yAxisSecondName,
            data: optionData.categories || [],
            axisLabel: {
              textStyle: {
                color: this.option.nameColor || '#333',
                fontSize: this.option.yNameSecondFontSize || 14
              },
              formatter: value => {
                const { yAxisSecondShow, yValueSecondFormatPath = [] } = this.option;
                if (yAxisSecondShow && yValueSecondFormatPath.length > 0) {
                  return formatByPath(yValueSecondFormatPath, value);
                } else {
                  return value;
                }
              }
            },
            axisLine: {
              lineStyle: {
                color: this.option.lineColor || '#333'
              }
            },
            inverse: this.vaildData(this.option.yAxisSecondInverse, false),
            show: this.vaildData(this.option.yAxisSecondShow, false),
            splitLine: {
              show: this.vaildData(this.option.yAxisSplitLineSecondShow, false)
            }
          }
        ],
        series: (() => {
          this.option.barColor || [];
          const list = (optionData.series || []).map((ele, index) => {
            return Object.assign(ele, {
              type: ele.type || 'bar',
              stack: ele.stack,
              barWidth: this.option.barWidth || 16,
              barMinHeight: this.option.barMinHeight || 0,
              itemStyle: this.ishasprop(
                !this.switchTheme,
                {
                  color:
                    this.option.various == false
                      ? this.getColor(index)
                      : params => this.getColor(params.dataIndex)
                },
                { barBorderRadius: this.option.barRadius || 0 }
              ),
              label: {
                show: this.vaildData(this.option.labelShow, false), //开启显示
                position: 'right', //在右方显示,
                formatter: name => this.getLabelFormatter(name),
                textStyle: {
                  //数值样式
                  fontSize: this.option.labelShowFontSize || 14,
                  color: this.option.labelShowColor || '#333',
                  fontWeight: this.option.labelShowFontWeight || 500
                }
              }
            });
          });
          return list;
        })()
      };

      this.myChart.resize();
      this.myChart.setOption(option, true);
      this.chartClick();
    }
  }
};
</script>
